var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.product.screen === 'one')?_c('EditProductFormOne'):(this.product.screen === 'two')?_c('EditProductFormTwo'):_c('ProductMerchantView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }